import { render, staticRenderFns } from "./campaignLandingPage.vue?vue&type=template&id=2f8f27a4&scoped=true"
import script from "./campaignLandingPage.vue?vue&type=script&lang=js"
export * from "./campaignLandingPage.vue?vue&type=script&lang=js"
import style0 from "./campaignLandingPage.vue?vue&type=style&index=0&id=2f8f27a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f27a4",
  null
  
)

export default component.exports